import { useEffect, useRef } from 'react'
import {
  destroyAIOnboardingTour,
  hasSeenAIOnboarding,
  startAIOnboardingTour,
} from '../utils/aiOnboarding'

export default function AIOnboardingTour({
  enabled,
  blocked,
  onOpenAssistant,
  resumeToken = 0,
}) {
  const startedRef = useRef(false)
  const onOpenAssistantRef = useRef(onOpenAssistant)
  onOpenAssistantRef.current = onOpenAssistant

  const openAndContinue = () => {
    if (onOpenAssistantRef.current) {
      onOpenAssistantRef.current({ continueOnboarding: true })
    }
  }

  useEffect(() => {
    if (blocked) destroyAIOnboardingTour()
  }, [blocked])

  useEffect(() => {
    if (!enabled || blocked || startedRef.current) return
    if (hasSeenAIOnboarding()) return

    const timer = window.setTimeout(() => {
      if (startedRef.current) return
      startedRef.current = true
      startAIOnboardingTour({
        onOpenAssistant: openAndContinue,
      }).catch(() => {
        startedRef.current = false
      })
    }, 700)

    return () => window.clearTimeout(timer)
  }, [enabled, blocked])

  useEffect(() => {
    if (!enabled || blocked || !resumeToken) return

    const timer = window.setTimeout(() => {
      startAIOnboardingTour({
        force: true,
        startIndex: 1,
        onOpenAssistant: openAndContinue,
      }).catch(() => undefined)
    }, 400)

    return () => window.clearTimeout(timer)
  }, [enabled, blocked, resumeToken])

  useEffect(() => () => destroyAIOnboardingTour(), [])

  return null
}
